// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__Oc6q3","title":"ClientCherryInfo_title__1H3MV","itemText":"ClientCherryInfo_itemText__1QtdH"};